import { ICellRendererParams } from "@ag-grid-community/core";
import { Center, Flex, Icon, Text } from "@chakra-ui/react";
import { TransactionCodeConfigData } from "gen/model/transactionCodeConfigData";
import { BiSolidCheckbox } from "react-icons/bi";
import { CheckIcon } from "shared/icons/CheckIcon";

export const TransactionWithActiveCellRenderer: React.FC<
  ICellRendererParams<
    TransactionCodeConfigData,
    string,
    { isEditable: boolean }
  >
> = ({ value, context, data }) => {
  const isActive = data?.state === "active";
  return (
    <Flex alignItems="center">
      {!context.isEditable && (
        <Center
          style={{
            display: "flex",
            alignItems: "center",
            height: "30px",
            width: "30px",
          }}
          mr="8px"
        >
          {isActive ? (
            <CheckIcon height="20px" width="20px" color="primary.500" />
          ) : (
            <Icon
              height="30px"
              width="30px"
              as={BiSolidCheckbox}
              color="gray.100"
            />
          )}
        </Center>
      )}
      <Text>{value}</Text>
    </Flex>
  );
};
